import { render, staticRenderFns } from "./AdminCommissions.vue?vue&type=template&id=4fb18c6b&scoped=true"
import script from "./AdminCommissions.vue?vue&type=script&lang=js"
export * from "./AdminCommissions.vue?vue&type=script&lang=js"
import style0 from "./AdminCommissions.vue?vue&type=style&index=0&id=4fb18c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb18c6b",
  null
  
)

export default component.exports